// extracted by mini-css-extract-plugin
export default {"container":"TagPost__container___AaTJx","modalHeaderTitle":"TagPost__modalHeaderTitle___LR_gr"};